<div class="pdf-view-ust-veri-area">
    <div  class="form-content" >
      <dx-form *ngIf="gelenGiden === 'G'" id="form" #form [(formData)]="bysBelge" [colCount]="2" [showColonAfterLabel]="true"
        [labelMode]="labelMode" [labelLocation]="labelLocation" [readOnly]="isReadOnly">
    
  
      <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="4" [colSpan]="2">
        <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
          
            <dxi-item [dataField]="'GelenBirimKod'" [label]="{ text: 'Gelen Birim' }"
            >
            <dk-ctl-vgen-birim
            [code]="bysBelge?.GelenBirimKod" [labelText]="'Gelen Birim'"  [isReadOnly]="isReadOnly"
            [isActive]="false" [birimTuru]="'A'"
            [labelMode]="labelMode" [isOnlyGrid]="true"
            ></dk-ctl-vgen-birim>
        </dxi-item>
        <dxi-item [dataField]="'GelenBirimAciklama'" [label]="{ text: 'Açıklama' }"
        >
    </dxi-item>
      </dxi-item>
      
      
      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        <dxi-item [label]="{ text: 'SDP Kodu' }" dataField="DosyaPlanKod" >
          <dk-ctl-gen-kontrol 
          #control [isReadOnly]="isReadOnly" [labelText]="'SDP Kodu'" [code]="bysBelge?.DosyaPlanKod"
            [controlName]="'GenDosyaPlanGenel'" [labelMode]="labelMode"></dk-ctl-gen-kontrol>
    
        </dxi-item>
        </dxi-item>




        <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
            <dxi-item [label]="{ text: 'Konu' }" dataField="BelgeAdi">
            </dxi-item>
            <dxi-item [label]="{ text: 'Alındı Tarihi' }" dataField="GonderAlTarih" editorType="dxDateBox">
            </dxi-item>
      </dxi-item>

      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        
        <dxi-item [label]="{ text: 'Dağıtım Tür' }" dataField="DagitimSekli">
          <dk-ct-gen-lookup  [labelMode]="labelMode" [selectedValue]="bysBelge?.DagitimSekli" [valueExpr]="'ozelKod'"
          (valueChange)="bysBelge.DagitimSekli = $event.value" [lookUpType]="'BYS_DAGITIM_SEKLI_LOOKUP'" [readOnly]="isReadOnly"
          [label]="'Dagıtım Tür'"></dk-ct-gen-lookup>
        </dxi-item>
        <dxi-item [label]="{ text: 'Belge Tarihi' }" dataField="BelgeTarih" editorType="dxDateBox">
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        
        <dxi-item dataField="GuvenlikDurumu" [label]="{ text: 'Gizlilik' }">
          
            <dk-ct-gen-lookup [placeholder]="'Gizlilik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.GuvenlikDurumu" [valueExpr]="'kod'"
            (valueChange)="bysBelge.GuvenlikDurumu = $event.value" [lookUpType]="'BYS_GUVENLIK_DURUM_LOOKUP'" [readOnly]="isReadOnly"
            [label]="'Gizlilik'"></dk-ct-gen-lookup>
          </dxi-item>
          <dxi-item [label]="{ text: 'Belge No' }" dataField="BelgeNo">
          </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
      
        <dxi-item [label]="{ text: 'Öncelik ' }" dataField="OncelikDurumu">
          <dk-ct-gen-lookup [placeholder]="'Öncelik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.OncelikDurumu" [valueExpr]="'ozelKod'"
          (valueChange)="bysBelge.OncelikDurumu = $event.value" [lookUpType]="'BYS_ONCELIK_DURUMU_LOOKUP'" [readOnly]="isReadOnly"
          [label]="'Öncelik'"></dk-ct-gen-lookup>
        </dxi-item>
      
      <!-- DKM-2954 Clara: eski hâli (İvedi evrakta da Cevap Tarihi olabiliyor)
      <dxi-item *ngIf="bysBelge?.OncelikDurumu==='G'" [label]="{ text: 'Cevap Tarihi' }" dataField="BeklenenDonusTarih" editorType="dxDateBox"> -->
      <dxi-item *ngIf="bysBelge?.OncelikDurumu==='G' || bysBelge?.OncelikDurumu==='I'" [label]="{ text: 'Cevap Tarihi' }" dataField="BeklenenDonusTarih" editorType="dxDateBox">
      </dxi-item>
    </dxi-item>
    <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
        <dxi-item [label]="{ text: 'Belge Tipi' }" dataField="BelgeTuru">
          <dk-ct-gen-lookup [placeholder]="'Belge Tipi'" [labelMode]="labelMode" [selectedValue]="bysBelge?.BelgeTuru"
          (valueChange)="bysBelge.BelgeTuru = $event.value" [lookUpType]="'BYS_YAZIISMA_ORTAM_TUR'" [readOnly]="isReadOnly"
          [label]="'Belge Tipi'"></dk-ct-gen-lookup>
        </dxi-item>
  </dxi-item>
  <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
    <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="1" [colSpan]="1">
      <dxi-item [label]="{ text: 'Belge Dili ' }" dataField="DilKod">
        
        <dk-ct-gen-lookup [placeholder]="'Belge Dili'" [labelMode]="labelMode" [selectedValue]="bysBelge?.DilKod" [valueExpr]="'kod'"
        (valueChange)="bysBelge.DilKod = $event.value" [lookUpType]="'GKOD_BELGE_YAZISMA_DIL'" [readOnly]="isReadOnly"
        [label]="'Belge Dili'"></dk-ct-gen-lookup>
      </dxi-item>
      <dxi-item 
      [label]="{ text: 'Geliş Şekli' }"
      dataField="GelisTurKod"
    >
    <div *dxTemplate>
  
      <dk-ct-gen-lookup
        [placeholder]="'Geliş Şekli'"
        [selectedValue]="bysBelge?.GelisTurKod"
        [valueExpr]="'kod'"
        [readOnly]="isReadOnly"
        [lookUpType]="'GKOD_BELGE_GIDIS_SEKLI'"
        [labelMode]="labelMode"
        [label]="'Geliş Şekli'"
      ></dk-ct-gen-lookup>
      </div>
    </dxi-item>
  
      </dxi-item>
      <dxi-item [label]="{ text: 'Açıklama' }" dataField="BelgeAciklama" editorType="dxTextArea">
      </dxi-item>
</dxi-item>


      </dxi-item>
  
  
  
  
  
       
  
  
  
      <dxi-item cssClass="header" itemType="group" caption="Diğer Bilgiler" [colCount]="2" [colSpan]="2">
        
        <dxi-item itemType="group" [colCount]="5" [colSpan]="2">
          <dxi-item
            [label]="{ text: 'Dilekçe' }"
            editorType="dxCheckBox"
            [editorOptions]="{
              value: bysBelge?.DilekceEh === 'E'
            }"
          ></dxi-item>
          <dxi-item
            [label]="{ text: 'Aslı Alındı' }"
            editorType="dxCheckBox"
            [editorOptions]="{
              value: bysBelge?.AsliAlindiEh === 'E',
            }"
          ></dxi-item>

          <dxi-item
            [label]="{ text: 'Bilgi Edinme' }"
            editorType="dxCheckBox"
            [editorOptions]="{
              value: bysBelge?.BilgiEdinmeEh === 'E',
            }"
          ></dxi-item>

          <dxi-item
            [label]="{ text: 'Telif Kapsamı' }"
            editorType="dxCheckBox"
            [editorOptions]="{
              value: bysBelge?.TelifKapsamindaEh === 'E',
            }"
          ></dxi-item>
          <dxi-item
            [label]="{ text: 'Kişisel' }"
            editorType="dxCheckBox"
            [editorOptions]="{
              value: bysBelge?.KisiselEh === 'E',
            }"
          ></dxi-item>

        </dxi-item>
          
          <dxi-item itemType="group" [colCount]="2" [colSpan]="2" >
          <dxi-item
          [label]="{ text: 'Tc Kimlik No' }"
            dataField="TcknNo"
            [editorOptions]="{ mask: '00000000000' }"
          >
          </dxi-item>
            <dxi-item  [colSpan]="2" [editorType]="'dxDateBox'" [label]="{text:'D.Tarih'}"
            >
            </dxi-item>

          
        </dxi-item>
        <dxi-item itemType="group" [colCount]="2" [colSpan]="2" >
          <dxi-item dataField="BilgiAdSoyad"
          [label]="{ text: 'Ad Soyad' }">

          </dxi-item>
          
            <dxi-item
            [label]="{ text: 'Cep Telefonu' }"
            dataField="GsmTelefonNo"
            [editorOptions]="gsmEditorOptions"
          >
          <!-- DKM-5486 Cedric: eski hâli [editorOptions]="{ mask: '(000) 000 00 00' }" -->
          </dxi-item>
        </dxi-item>
          

        <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                <dxi-item
                [label]="{ text: 'Ada' }"
                dataField="Ada"
                editorType="dxNumberBox"
                >
              </dxi-item>
              <dxi-item
              [label]="{ text: 'Parsel' }"
              dataField="Parsel"
              editorType="dxNumberBox"
              >
            </dxi-item>
    </dxi-item>

        
    <dxi-item itemType="group" [colSpan]="1" [colCount]="1">
        <dxi-item cssClass="control"
        dataField="KisiKod"
        [label]="{ text: 'Sicil' }"
          >
          <div *dxTemplate>
  
          <dk-ctl-gen-kisi
          #control
          [code]="bysBelge?.KisiKod"
          [isReadOnly]="isReadOnly"
          [labelText]="'Sicil'"
            [labelMode]="labelMode"
            ></dk-ctl-gen-kisi>
            </div>
          </dxi-item>
        <dxi-item cssClass="control"
        dataField="PersonelKod"
        [label]="{ text: 'Personel' }"
        >
        <div *dxTemplate>

        <dk-ctl-ika-personel
        #control
        [labelText]="'Personel'"
        [isReadOnly]="isReadOnly"
        [code]="bysBelge?.PersonelKod"
        [labelMode]="labelMode"
        ></dk-ctl-ika-personel>
        </div>
      </dxi-item>
    </dxi-item>
    
        
      </dxi-item>


      </dx-form>









      <dx-form *ngIf="gelenGiden === 'I'" id="form" #form [(formData)]="bysBelge" [colCount]="2" [showColonAfterLabel]="true"
      [labelMode]="labelMode" [labelLocation]="labelLocation" [readOnly]="isReadOnly">
  
  
   
  
      <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="4" [colSpan]="2">
        <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
          
          <dxi-item [dataField]="'BirimKod'" [label]="{ text: 'Birimi' }"
          >
          <dk-ctl-vgen-birim
          [code]="bysBelge?.BirimKod" [labelText]="'Birimi'"  [isReadOnly]="isReadOnly"
          [isActive]="false" [birimTuru]="'A'"
          [labelMode]="labelMode" [isOnlyGrid]="true"
          ></dk-ctl-vgen-birim>
        </dxi-item>
      </dxi-item>
      
      
      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        <dxi-item [label]="{ text: 'SDP Kodu' }" dataField="DosyaPlanKod" >
          <dk-ctl-gen-kontrol 
          #control [isReadOnly]="isReadOnly" [labelText]="'SDP Kodu'" [code]="bysBelge?.DosyaPlanKod"
            [controlName]="'GenDosyaPlanGenel'" [labelMode]="labelMode"></dk-ctl-gen-kontrol>
    
        </dxi-item>
        </dxi-item>




        <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
            <dxi-item [label]="{ text: 'Konu' }" dataField="BelgeAdi">
            </dxi-item>
      
            <dxi-item [label]="{ text: 'Özel No' }" dataField="OzelNo">
            </dxi-item>
      </dxi-item>

      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        
        <dxi-item [label]="{ text: 'Dağıtım Tür' }" dataField="DagitimSekli">
          <dk-ct-gen-lookup  [labelMode]="labelMode" [selectedValue]="bysBelge?.DagitimSekli" [valueExpr]="'ozelKod'"
          (valueChange)="bysBelge.DagitimSekli = $event.value" [lookUpType]="'BYS_DAGITIM_SEKLI_LOOKUP'" [readOnly]="isReadOnly"
          [label]="'Dagıtım Tür'"></dk-ct-gen-lookup>
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2" [colSpan]="4">
        
        <dxi-item dataField="GuvenlikDurumu" [label]="{ text: 'Gizlilik' }">
          
            <dk-ct-gen-lookup [placeholder]="'Gizlilik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.GuvenlikDurumu" [valueExpr]="'kod'"
            (valueChange)="bysBelge.GuvenlikDurumu = $event.value" [lookUpType]="'BYS_GUVENLIK_DURUM_LOOKUP'" [readOnly]="isReadOnly"
            [label]="'Gizlilik'"></dk-ct-gen-lookup>
          </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
      
        <dxi-item [label]="{ text: 'Öncelik ' }" dataField="OncelikDurumu">
          <dk-ct-gen-lookup [placeholder]="'Öncelik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.OncelikDurumu" [valueExpr]="'ozelKod'"
          (valueChange)="bysBelge.OncelikDurumu = $event.value" [lookUpType]="'BYS_ONCELIK_DURUMU_LOOKUP'" [readOnly]="isReadOnly"
          [label]="'Öncelik'"></dk-ct-gen-lookup>
        </dxi-item>
      
      <!-- DKM-2954 Clara: eski hâli (İvedi evrakta da Cevap Tarihi olabiliyor)
      <dxi-item *ngIf="bysBelge?.OncelikDurumu==='G'" [label]="{ text: 'Cevap Tarihi' }" dataField="BeklenenDonusTarih" editorType="dxDateBox"> -->
      <dxi-item *ngIf="bysBelge?.OncelikDurumu==='G' || bysBelge?.OncelikDurumu==='I'" [label]="{ text: 'Cevap Tarihi' }" dataField="BeklenenDonusTarih" editorType="dxDateBox">
      </dxi-item>
    </dxi-item>
    <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="4">
        <dxi-item [label]="{ text: 'Belge Tipi' }" dataField="BelgeTuru">
          <dk-ct-gen-lookup [placeholder]="'Belge Tipi'" [labelMode]="labelMode" [selectedValue]="bysBelge?.BelgeTuru"
          (valueChange)="bysBelge.BelgeTuru = $event.value" [lookUpType]="'BYS_YAZIISMA_ORTAM_TUR'" [readOnly]="isReadOnly"
          [label]="'Belge Tipi'"></dk-ct-gen-lookup>
        </dxi-item>
  </dxi-item>

  <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="1" [colSpan]="2">
    <dxi-item [label]="{ text: 'Belge Dili ' }" dataField="DilKod"[colSpan]="2">
      
      <dk-ct-gen-lookup [placeholder]="'Belge Dili'" [labelMode]="labelMode" [selectedValue]="bysBelge?.DilKod" [valueExpr]="'kod'"
      (valueChange)="bysBelge.DilKod = $event.value" [lookUpType]="'GKOD_BELGE_YAZISMA_DIL'" [readOnly]="isReadOnly"
      [label]="'Belge Dili'"></dk-ct-gen-lookup>
    </dxi-item>
    <dxi-item [label]="{ text: 'Açıklama' }" dataField="BelgeAciklama" editorType="dxTextArea">
    </dxi-item>
    <dxi-item [label]="{ text: 'Bilgi Ad Soyad' }" dataField="BilgiAdSoyad">
    </dxi-item>

    <dxi-item [label]="{ text: 'Bilgi Telefon' }" dataField="BilgiTelNo">
    </dxi-item>
    </dxi-item>
    <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="2">
        <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="2">
            <dxi-item [label]="{ text: 'Ada' }" dataField="Ada" editorType="dxNumberBox">
            </dxi-item>
            <dxi-item [label]="{ text: 'Parsel' }" dataField="Parsel" editorType="dxNumberBox">
            </dxi-item>
        </dxi-item>
        <dxi-item [label]="{ text: 'Anahtar' }" dataField="AnahtarKelime" editorType="dxTextArea"[colSpan]="2">
        </dxi-item>
        <dxi-item [label]="{ text: 'Bilgi Unvani' }" dataField="BilgiUnvani"[colSpan]="2">
        </dxi-item>
    
        <dxi-item [label]="{ text: 'Bilgi E-Posta' }" dataField="BilgiEPosta"[colSpan]="2">
        </dxi-item>
    </dxi-item>



      </dxi-item>
  
  
  
  
  
       
  
  
  
      <dxi-item cssClass="header" itemType="group" caption="Diğer Bilgiler" [colCount]="2" [colSpan]="2">
        <dxi-item  itemType="group" [colCount]="2" [colSpan]="2">
            <dxi-item dataField="KisiKod">
              <dk-ctl-gen-kisi 
              #control [code]="bysBelge?.KisiKod" [labelText]="'Sicil'" [isReadOnly]="isReadOnly"
                [labelMode]="labelMode"></dk-ctl-gen-kisi>
            </dxi-item>
        </dxi-item>
        <dxi-item  itemType="group" [colCount]="2" [colSpan]="2">
            <dxi-item dataField="PersonelKod">
              <dk-ctl-ika-personel 
              #control [labelText]="'Personel'" [code]="bysBelge?.PersonelKod" [isReadOnly]="isReadOnly"
                [labelMode]="labelMode"></dk-ctl-ika-personel>
            </dxi-item>
        </dxi-item>
  
  
      </dxi-item>
  
    </dx-form>












      <div class="eyp-area" *ngIf="bysBelgeDetay">
        <span>Eyp Durumu: {{bysBelgeDetay?.EypStatus === 1?'İmzada':bysBelgeDetay?.EypStatus === 2?'İmzalandı':''}}</span>
        <dx-button *ngIf="bysBelgeDetay?.EypDysId?true:false" width="100px" icon="download"
        stylingMode="contained" type="default" text="Eyp İndir" (click)="eypIndirClick()"></dx-button>
    
      </div>
      
    
      
      <dx-load-panel #loadPanel container="#form" [showIndicator]="true" shadingColor="rgba(0,0,0,0.2)"
      [showPane]="false" [shading]="true" [visible]="(isLoading && state === 'Edit')" [position]="{ of: '#form' }"></dx-load-panel>
    </div>
  </div>